<template>
  <div>
    <div class="payments">
     <div class="container">
        <div class="row">
            <div class="col-12">
                <router-link :to="{name: 'home'}">
                    <button class="btn mb-3 pull-left">
                        « Home
                    </button>
                </router-link>
                <router-link :to="{name: 'Account'}">
                    <button class="btn mb-3 pull-right">
                        Profile »
                    </button>
                </router-link>
            </div>
        </div>

        <div class="payment-wrapper">
            <!-- Left Side - Payment List -->
            <div class="payment-list">
                <h2>Select Payment Method</h2>
                <div class="payment-item" v-for="payment in payments" v-if="payment.is_active" :class="($route.params.method === payment.key) ? 'active' : ''">
                    <div class="payment-icon">
                      <img :src="'static/assets/img/payments/'+payment.key+'.png'" width="20"/>
                    </div>
                    <div class="payment-info">
                      <router-link :to="{params: {method: payment.key, withdraw: 'pay'}, query: {t: payment.gateway}}">
                        <div class="payment-name">{{ payment.name }}</div>
                        <div class="payment-description">{{ payment.information }}</div>
                      </router-link>
                    </div>
                </div>
            </div>
            
            <!-- Right Side - Payment Details -->
            <div class="payment-details">
                <!-- Default Empty State -->
                <div class="empty-state" id="empty-state" v-show="!$route.params.method">
                    <div class="empty-state-icon">💳</div>
                    <h3>Select a payment method</h3>
                    <p>Choose a payment option from the left to continue</p>
                </div>

                <div class="order" v-show="!$route.params.method">
                    <order/>
                </div>
                
                <!-- Credit Card Details -->
                <div class="detail-section p-5" v-show="$route.params.method">
                      <extend v-if="$route.query.t !== 'default'"></extend>
                      <component v-if="$route.query.t === 'default'" :is="$route.params.method" v-bind="{ view: 'withdraw', kind: $route.query.t}"></component>
                </div>
                
            </div>
        </div>
    </div>
  
    </div>
    <sweet-modal ref="modal" width="800">
      <extend v-if="$route.query.t != 'default'"></extend>
      <component v-else :is="$route.params.method" v-bind="{ view: $route.params.withdraw, kind: $route.query.t}"></component>
    </sweet-modal>
  </div>
</template>

<script>
import Payment from '@/components/payments/item';
import cep_bank from '@/components/payments/gateways/cepbank';
import papara from '@/components/payments/gateways/papara';
import paykasa from '@/components/payments/gateways/paykasa';
import jeton from '@/components/payments/gateways/jeton'
import peppara from '@/components/payments/gateways/peppara'
import bank_transfer from '@/components/payments/gateways/bank_transfer'
import coin_payments from '@/components/payments/gateways/coinpayments'
import extend from '@/components/payments/gateways/extend'
import BetSlip from '@/components/sportsbook/BetSlip';
import order from '@/components/payments/order'

export default {
  name: 'payments',
  components: {Payment, cep_bank, papara, paykasa, jeton, peppara, bank_transfer, coin_payments, BetSlip, extend, order},
  data() {
    return {
      session: window.session,
      api: window.api,
      t: this.$root.t,
      payments: null
    }
  },
  mounted() {
    this.fetchPayments();
  },
  methods: {
    fetchPayments() {
      if (!this.isLoading) {
        this.isLoading = true;
        this.$http.get(this.api + 'api/v1/payment/methods',
            {params: this.$route.query}).then(response => {

          this.pagination = response.body.result.pagination;
          this.payments = Object.values(response.body.result.payments);
          this.status = response.status;

          this.isLoading = false;
        }, response => {
          this.isLoading = false;
          this.status = response.status;
        })
      }
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

        .container {
            max-width: 1200px;
            margin: 0 auto;
            padding: 20px;
        }

        h1 {
            margin-bottom: 30px;
            color: #2c3e50;
            font-size: 28px;
        }

        .payment-wrapper {
            display: flex;
            gap: 30px;
            background: white;
            border-radius: 12px;
            box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
            overflow: hidden;
            min-height: 500px;
        }

        /* Left Side - Payment List */
        .payment-list {
            flex: 0 0 350px;
            background-color: #f8f9fa;
            padding: 30px;
            border-right: 1px solid #e0e0e0;
            height: 80vh;
            overflow-y: scroll;
            box-shadow: -14px 2px 25px -20px rgba(0, 0, 0, 0.5) inset;
        }

        .payment-list h2 {
            font-size: 20px;
            margin-bottom: 20px;
            color: #2c3e50;
        }

        .payment-item {
            display: flex;
            align-items: center;
            padding: 15px;
            margin-bottom: 10px;
            background: white;
            border: 2px solid #e0e0e0;
            border-radius: 8px;
            cursor: pointer;
            transition: all 0.3s ease;
        }

        .payment-item:hover {
            border-color: #3498db;
            transform: translateY(-2px);
            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
        }

        .payment-item.active {
            border-color: #3498db;
            background-color: #e8f4f8;
        }

        .payment-icon {
            width: 40px;
            height: 40px;
            margin-right: 15px;
            display: flex;
            align-items: center;
            justify-content: center;
            background-color: #f0f0f0;
            border-radius: 8px;
            font-size: 20px;
        }

        .payment-info {
            flex: 1;
        }

        .payment-name {
            font-weight: 600;
            margin-bottom: 3px;
        }

        .payment-description {
            font-size: 13px;
            color: #666;
        }

        /* Right Side - Payment Details */
        .payment-details {
            flex: 1;
            height: 80vh;
            overflow-y: scroll;
        }

        .payment-details h2 {
            font-size: 24px;
            margin-bottom: 20px;
            color: #2c3e50;
        }

        .detail-section {
        }

        .detail-section.active {
            display: block;
            animation: fadeIn 0.3s ease;
        }

        @keyframes fadeIn {
            from {
                opacity: 0;
                transform: translateY(10px);
            }
            to {
                opacity: 1;
                transform: translateY(0);
            }
        }

        .form-group {
            margin-bottom: 20px;
        }

        .form-group label {
            display: block;
            margin-bottom: 8px;
            font-weight: 500;
            color: #555;
        }

        .form-group input,
        .form-group select {
            width: 100%;
            padding: 12px;
            border: 2px solid #e0e0e0;
            border-radius: 6px;
            font-size: 16px;
            transition: border-color 0.3s ease;
        }

        .form-group input:focus,
        .form-group select:focus {
            outline: none;
            border-color: #3498db;
        }

        .card-row {
            display: flex;
            gap: 15px;
        }

        .card-row .form-group {
            flex: 1;
        }

        .submit-button {
            background-color: #3498db;
            color: white;
            padding: 14px 30px;
            border: none;
            border-radius: 6px;
            font-size: 16px;
            font-weight: 600;
            cursor: pointer;
            transition: background-color 0.3s ease;
            margin-top: 20px;
        }

        .submit-button:hover {
            background-color: #2980b9;
        }

        .empty-state {
            text-align: center;
            padding: 60px;
            color: #999;
        }

        .empty-state-icon {
            font-size: 48px;
            margin-bottom: 20px;
        }

/* Responsive Design */
@media (max-width: 968px) {
    .payment-wrapper {
        flex-direction: column;
        height: auto;
        min-height: auto;
    }

    .payment-list {
        flex: none;
        width: 100%;
        height: auto;
        max-height: 200px;
        border-right: none;
        border-bottom: 1px solid #e0e0e0;
        padding: 20px;
        overflow-x: auto;
        overflow-y: hidden;
        display: flex;
        flex-direction: column;
        -webkit-overflow-scrolling: touch;
    }

    .payment-list h2 {
        flex-shrink: 0;
        margin-bottom: 15px;
    }

    /* Create horizontal scroll by changing flex direction after h2 */
    .payment-list h2 + .payment-item {
        margin-left: 0;
    }

    .payment-item {
        display: inline-flex;
        flex: 0 0 auto;
        width: 200px;
        margin-right: 15px;
        margin-bottom: 0;
        vertical-align: top;
    }

    /* Use white-space to prevent wrapping */
    .payment-list {
        white-space: nowrap;
    }

    .payment-list h2 {
        white-space: normal;
    }

    .payment-details {
        height: auto;
        padding: 30px 20px;
        overflow-y: visible;
    }
}

/* For even better mobile experience */
@media (max-width: 768px) {
    .container {
        padding: 15px;
    }

    h1 {
        font-size: 24px;
        margin-bottom: 20px;
        display: none;
    }

    .payment-list {
        padding: 15px;
        padding-bottom: 20px;
    }

    .payment-item {
        width: 200px;
        padding: 5px;
    }

    .payment-icon {
        width: 35px;
        height: 35px;
        font-size: 18px;
    }

    .payment-details {
        padding: 20px;
    }
}

@media (max-width: 480px) {
    h1 {
        font-size: 20px;
    }

    .payment-item {
        width: 200px;
        padding: 10px;
    }

    .payment-icon {
        width: 30px;
        height: 30px;
        font-size: 16px;
        margin-right: 10px;
    }

    .payment-name {
        font-size: 14px;
    }

    .payment-description {
        font-size: 12px;
    }

    .payment-details {
        padding: 15px;
    }
}

/* Scrollbar styling */
.payment-list::-webkit-scrollbar {
    height: 6px;
    width: 6px;
}

.payment-list::-webkit-scrollbar-track {
    background: #f1f1f1;
}

.payment-list::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 3px;
}

        

button {
  cursor: pointer
}
.payments {
  padding: 5% 10%;
}

/*//////////////////////////////////////////////////////////////////
[ Table ]*/
.payment {
  font-size: 104px;
  text-align: center;
  opacity: 0.3;
}
.limiter {
  width: 100%;
  margin: 0 auto;
}

.container-table100 {
  width: 100%;
  min-height: 100vh;
  background: #c850c0;
  background: -webkit-linear-gradient(45deg, #4158d0, #c850c0);
  background: -o-linear-gradient(45deg, #4158d0, #c850c0);
  background: -moz-linear-gradient(45deg, #4158d0, #c850c0);
  background: linear-gradient(45deg, #4158d0, #c850c0);

  display: -webkit-box;
  display: -webkit-flex;
  display: -moz-box;
  display: -ms-flexbox;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  padding: 33px 30px;
}

.wrap-table100 {
  width: 1170px;
}

table {
  border-spacing: 1;
  border-collapse: collapse;
  background: white;
  border-radius: 10px;
  overflow: hidden;
  width: 100%;
  margin: 0 auto;
  position: relative;
  box-shadow: 0px 0px 66px -20px rgba(0,0,0,0.67);
-webkit-box-shadow: 0px 0px 66px -20px rgba(0,0,0,0.67);
-moz-box-shadow: 0px 0px 66px -20px rgba(0,0,0,0.67);
}
table * {
  position: relative;
}
table td, table th {
  padding-left: 8px;
}
table thead tr {
  height: 60px;
  background: #36304a;
  color: white;
}
table tbody tr {
  height: 50px;
}
table tbody tr:last-child {
  border: 0;
}
table td, table th {
  text-align: left;
}
table td.l, table th.l {
  text-align: right;
}
table td.c, table th.c {
  text-align: center;
}
table td.r, table th.r {
  text-align: center;
}


.table100-head th{
  font-size: 18px;
  color: #fff;
  line-height: 1.2;
  font-weight: unset;
}

tbody tr:nth-child(even) {
  background-color: #f5f5f5;
}

tbody tr {
  font-size: 16px;
  color: #808080;
  line-height: 1.2;
  font-weight: unset;
}

tbody tr:hover {
  color: #555555;
  background-color: #f5f5f5;
  cursor: pointer;
}

.column1 {
  width: 260px;
  padding-left: 40px;
}

.column2 {
  width: 160px;
}

.column3 {
  width: 245px;
}

.column4 {
  width: 110px;
  text-align: right;
}

.column5 {
  width: 170px;
  text-align: right;
}

.column6 {
  width: 222px;
  text-align: right;
  padding-right: 62px;
}

/* Responsive Design */
@media (max-width: 968px) {
    .payment-wrapper {
        flex-direction: column;
        height: auto;
        min-height: auto;
    }

    .payment-list {
        flex: none;
        width: 100%;
        height: auto;
        border-right: none;
        border-bottom: 1px solid #e0e0e0;
        padding: 20px;
        overflow-x: auto;
        overflow-y: hidden;
        -webkit-overflow-scrolling: touch;
        
        /* Grid layout for horizontal scroll */
        display: grid;
        grid-auto-flow: column;
        grid-auto-columns: 200px;
        gap: 15px;
        
        /* Add padding for scroll */
        padding-bottom: 25px;
    }

    /* Keep h2 above the grid */
    .payment-list h2 {
        grid-column: 1 / -1;
        margin-bottom: 15px;
        display: none;
    }

    .payment-item {
        margin: auto;
        overflow: hidden;
        width: 200px;
    }

    /* Alternative approach using flexbox */
    /* .payment-list {
        display: flex;
        flex-wrap: nowrap;
        overflow-x: auto;
        overflow-y: hidden;
        gap: 15px;
        padding-bottom: 25px;
    }

    .payment-list h2 {
        position: sticky;
        left: 0;
        flex: 0 0 100%;
        margin-bottom: 15px;
    }

    .payment-item {
        flex: 0 0 200px;
        margin-bottom: 0;
    } */

    .payment-details {
        height: auto;
        padding: 30px 20px;
        overflow-y: visible;
    }
}

/* For tablets and mobile */
@media (max-width: 768px) {

    .payments {
        padding: 0;
        margin: 0;
    }
    .container {
        padding: 0;
        margin: 0;
    }

    h1 {
        font-size: 24px;
        margin-bottom: 20px;
    }

    .payment-list {
        padding: 15px;
        grid-auto-columns: 180px;
        gap: 12px;
    }

    .payment-item {
        padding: 12px;
    }

    .payment-icon {
        width: 35px;
        height: 35px;
        font-size: 18px;
    }

    .payment-details {
        padding: 20px;
    }
}

@media (max-width: 480px) {
    h1 {
        font-size: 20px;
    }

    .payment-list {
        grid-auto-columns: 200px;
        gap: 10px;
    }

    .payment-item {
        padding: 10px;
    }

    .payment-icon {
        width: 30px;
        height: 30px;
        font-size: 16px;
        margin-right: 10px;
    }

    .payment-name {
        font-size: 14px;
    }

    .payment-description {
        font-size: 12px;
    }

    .payment-details {
        padding: 15px;
    }
}

/* Scrollbar styling */
.payment-list::-webkit-scrollbar {
    height: 8px;
}

.payment-list::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 4px;
}

.payment-list::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 4px;
}

.payment-list::-webkit-scrollbar-thumb:hover {
    background: #555;
}

@keyframes fadeIn {
    from {
        opacity: 0;
        transform: translateY(10px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

</style>



// WEBPACK FOOTER //
// src/components/payments/payments.vue